import React from 'react';
import PropTypes from 'prop-types';

import Check from '../../images/check.svg';
import Styles from './Checkbox.styles';

export const Checkbox = ({
  checked,
  name,
  onChange,
  value,
}) => (
  <div className={Styles.wrapper}>
    <input
      checked={checked}
      className={Styles.checkbox}
      name={name}
      onChange={onChange}
      type="checkbox"
      value={value}
    />
    <Check className={Styles.check} />
  </div>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: null,
  name: null,
  onChange: undefined,
  value: false,
};
